import * as React from 'react';

import { Theme } from '@mui/material/styles';

import { Dialog, DialogContent, DialogActions, Button, IconButton } from '@mui/material';
import Close from '@mui/icons-material/Close';


/**/
import EditorDef from '../../../../editor/core/model/EditorDef';
import Editor from '../../../../editor/core/Editor';

import IEditorModeChangeListener from '../../../../editor/core/listeners/IEditorModeChangeListener';
import { 
    EditorMode, 
    resourcesBaseUrl 
} from '../../../../editor/core/EditorConstants';
import { WithTranslation, withTranslation } from 'react-i18next';
import Logger from '../../../../common/log/Logger';
import NotificationSnackBar from '../utils/NotificationSnackBar';
import EditorObject from '../../../../editor/core/objects/EditorObject';
import theme from 'src/common/ui/theme';

/**image editor */
import ImageEditor from '@wideo/react-image-editor'

const dialogImageEditorHeight = document.documentElement.clientHeight;
const dialogImageEditorWidth = document.documentElement.clientWidth;
const topMarginDialogContentImageEditor = 8; // Top maring of the dialog
const dialogimageEditorActions = 69; // The action buttons in the dialog
const imageEditorContainer = dialogImageEditorHeight - dialogimageEditorActions - topMarginDialogContentImageEditor;

const imageEditorControls = 64;         // The header and controls menu of the image editor
const imageEditorControlsSubMenu = 150; // The submenu that opens when choosing an tool in the editor
const imageEditorInternalPadding = 16;  // This is to add some space around the actual image canvas
const imageEditorHeight = imageEditorContainer - imageEditorControls - imageEditorControlsSubMenu - imageEditorInternalPadding;
const imageEditorWidth = dialogImageEditorWidth - imageEditorInternalPadding;

 const imageEditorWhiteTheme = {
    'common.bi.image': '',
    'common.bisize.width': '0px',
    'common.bisize.height': '0px',
    'common.backgroundImage': resourcesBaseUrl + '/img/editor/tui-image-editor/bg.png',
    'common.backgroundColor': '#fff',
    'common.border': '0px solid #c1c1c1',

    // header
    'header.backgroundImage': 'none',
    'header.backgroundColor': 'transparent',
    'header.border': '0px',
    'header.display': 'none',

    // load button
    // 'loadButton.backgroundColor': '#fff',
    // 'loadButton.border': '1px solid #ddd',
    // 'loadButton.color': '#222',
    // 'loadButton.fontFamily': '\'Noto Sans\', sans-serif',
    // 'loadButton.fontSize': '12px',
    'loadButton.display': 'none',

    // download button
    // 'downloadButton.backgroundColor': '#fdba3b',
    // 'downloadButton.border': '1px solid #fdba3b',
    // 'downloadButton.color': '#fff',
    // 'downloadButton.fontFamily': '\'Noto Sans\', sans-serif',
    // 'downloadButton.fontSize': '12px',
    'downloadButton.display': 'none',

    // main icons
    'menu.normalIcon.path': resourcesBaseUrl + '/img/editor/tui-image-editor/icon-d.svg',
    'menu.normalIcon.name': 'icon-d',
    'menu.activeIcon.path': resourcesBaseUrl + '/img/editor/tui-image-editor/icon-b.svg',
    'menu.activeIcon.name': 'icon-b',
    'menu.disabledIcon.path': resourcesBaseUrl + '/img/editor/tui-image-editor/icon-a.svg',
    'menu.disabledIcon.name': 'icon-a',
    'menu.hoverIcon.path': resourcesBaseUrl + '/img/editor/tui-image-editor/icon-c.svg',
    'menu.hoverIcon.name': 'icon-c',
    'menu.iconSize.width': '24px',
    'menu.iconSize.height': '24px',

    // submenu primary color
    'submenu.backgroundColor': '#151515',
    'submenu.partition.color': '#e5e5e5',

    // submenu icons
    'submenu.normalIcon.path': resourcesBaseUrl + '/img/editor/tui-image-editor/icon-d.svg',
    'submenu.normalIcon.name': 'icon-d',
    'submenu.activeIcon.path': resourcesBaseUrl + '/img/editor/tui-image-editor/icon-b.svg',
    'submenu.activeIcon.name': 'icon-b',
    'submenu.iconSize.width': '32px',
    'submenu.iconSize.height': '32px',

    // submenu labels
    'submenu.normalLabel.color': '#858585',
    'submenu.normalLabel.fontWeight': 'normal',
    'submenu.activeLabel.color': '#fff',
    'submenu.activeLabel.fontWeight': 'normal',

    // checkbox style
    'checkbox.border': '1px solid #ccc',
    'checkbox.backgroundColor': '#fff',

    // rango style
    'range.pointer.color': '#ccc',
    'range.bar.color': '#606060',
    'range.subbar.color': '#ccc',

    'range.disabledPointer.color': '#aaa',
    'range.disabledBar.color': '#606060',
    'range.disabledSubbar.color': '#606060',

    'range.value.color': '#fff',
    'range.value.fontWeight': 'normal',
    'range.value.fontSize': '11px',
    'range.value.border': '0',
    'range.value.backgroundColor': '#f5f5f5',
    'range.title.color': '#fff',
    'range.title.fontWeight': 'lighter',

    // colorpicker style
    'colorpicker.button.border': '0px',
    'colorpicker.title.color': '#fff'
};


export const getBackgroundLightColor = (theme: Theme) => ({
    backgroundColor: theme.palette.grey['100'],
  });

const styles = {
    dialog: {
        justifyContent: 'flex-center' as React.CSSProperties['justifyContent'],
    },
    dialogPaper: {
        minHeight: dialogImageEditorHeight,
        maxHeight: dialogImageEditorHeight,
    },
    dialogContent: {
        paddingBottom: 0,
        paddingRight: 10
    },
    imageEditorContainer: {
        minHeight: imageEditorContainer
    },
    iconActionClose: {
        width: '35px',
        height: '35px',
        margin: '15px',
        ...getBackgroundLightColor(theme),
        padding: '0',
        float: 'right' as React.CSSProperties['float'],
      }
};

interface Props {
    editor: Editor;
}

interface State {
    imageEditorDialogOpen: boolean;
    snackbarOpen: boolean;
}

type Styled = any

type PropsWithTranslationsAndStyles = Props & WithTranslation & Styled;


//type PropsWithTranslationsAndStyles = Props & WithTranslation & WithStyles<'dialog' | 'dialogPaper' | 'dialogContent' | 'imageEditorContainer' | 'iconActionClose'>;

class ImageEditorDialog extends React.Component<PropsWithTranslationsAndStyles, State> implements IEditorModeChangeListener {

    private editorRef = React.createRef();
    private tuiLocale = {};

    constructor(props: PropsWithTranslationsAndStyles) {
        super(props);
        this.state = {
            imageEditorDialogOpen: false,
            snackbarOpen: false
        }
    }

    //used to open toast ui image editor
    onEditorModeChange(mode: EditorMode): void {
        if (mode === EditorMode.EditImage) {
            const selected = this.props.editor.getSelection().getSelectedObject();
            //to edit need to be an image object or a maskedObject with an image inside and focused
            if (selected && (EditorDef.isImageObject(selected) || EditorDef.isMaskedObject(selected)) && selected.getFocus() && !this.state.imageEditorDialogOpen) {
                this.setState({ imageEditorDialogOpen: true });
            }
            // This loads the locale resource bundle in a format that TUI accepts, when later
            // rendering the Image Editor this.tuiLocale is passed in as prop
            this.tuiLocale = this.props.i18n.getResourceBundle(this.props.i18n.language, 'tui');
        }
        else {
            this.setState({ imageEditorDialogOpen: false });
        }
    }

    handleCloseImageEditorDialog = () => {
        this.props.editor.cancelEditImage();
        this.setState({ imageEditorDialogOpen: false });
    };

    renderImageEditor = () => {

        const selected: EditorObject = this.props.editor.getSelection().getSelectedObject() as EditorObject;

        if (selected && (EditorDef.isImageObject(selected) || EditorDef.isMaskedObject(selected))) {

            const image: string = this.props.editor.getAssetUrlFromImageObject(selected) + '?x-xhrx=true';
            if (image) {
                 return (
                    <ImageEditor
                        ref={this.editorRef}
                        includeUI={{
                            loadImage: {
                                path: image,
                                name: 'SampleImage'
                            },
                            theme: imageEditorWhiteTheme,
                            locale: this.tuiLocale,
                            uiSize: {
                                width: '100%',
                                height: imageEditorContainer + 'px'
                            },
                            menuBarPosition: 'top'
                        }}
                        cssMaxHeight={imageEditorHeight}
                        cssMaxWidth={imageEditorWidth}
                        usageStatistics={false}
                    />
                );
            }
        }
        return null;
    }

    onApply = async () => {
        this.handleCloseImageEditorDialog();
        // Avoid repeated clicks
        if (!this.props.editor.getEditorLockHandler().isLocked()) {
            try {
                // tslint:disable-next-line:no-any (There are no TS definitions for TUI react)
                await this.props.editor.replaceAssetSelectedWithEditedAsset(((this.editorRef.current as any).getInstance() as any).toDataURL());
            } catch (error) {
                Logger.error("The edited image can't be saved", error);
                this.setState({ snackbarOpen: true });
            }
        }
    }

    onCancel = () => {
        this.handleCloseImageEditorDialog();
    }

    closeSnackBarMessage = () => {
        this.setState({ snackbarOpen: false });
    }

    renderImageEditorDialog = () => {
        const { t } = this.props;

        return (
            <>
                <Dialog
                    open={this.state.imageEditorDialogOpen}
                    onClose={this.handleCloseImageEditorDialog} aria-labelledby="simple-dialog-title"
                    scroll='body'
                    fullWidth={true}
                    fullScreen={true}
                    style={{
                        ...styles.dialog,
                        ...styles.dialogPaper
                    }}
                    PaperProps={{
                        sx: { borderRadius: 0 }
                    }}                    
                >   <>
                        <IconButton
                            onClick={this.onCancel}
                            style={styles.iconActionClose}
                        >
                            <Close color="action" />
                        </IconButton>
                    </>
                    <DialogContent
                        style={{
                            ...styles.dialogContent,
                        }}>
                        <div style={styles.imageEditorContainer}>
                            {this.renderImageEditor()}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onCancel} color="primary">
                            {t("dialogs.image-editor.actions.cancel")}
                        </Button>
                        <Button onClick={this.onApply} variant="contained" color="primary">
                            {t("dialogs.image-editor.actions.apply")}
                        </Button>
                    </DialogActions>
                </Dialog>

                <NotificationSnackBar snackBarOpen={this.state.snackbarOpen}
                    snackBarText={t("dialogs.image-editor.error")}
                    snackBarError={true}
                    handleCloseSnackBar={this.closeSnackBarMessage}
                    parentComponent={'WorkAreaLeftBar'} />
            </>
        )
    }

    componentDidMount() {
        this.props.editor.addEditorModeChangeListener(this);
    }

    componentWillUnmount(): void {
        this.props.editor.removeEditorModeChangeListener(this);
    }

    render() {
        return (<this.renderImageEditorDialog />)
    }

}

export default withTranslation("dialogs")(ImageEditorDialog);
